module.exports = __webpack_public_path__ + "static/media/speech_bubble.403f8e8f.svg";